import {BaseAnimation} from './BaseAnimation';

export class ScrollLeftAnimation extends BaseAnimation {

    private fromValue:string|number|null=null;
    private toValue:string|number|null=null;

    public getClass():string {
        return 'scroll-left-animation';
    }

    public setCSS(e:JQuery<HTMLElement|SVGElement>,prop:string,value:string) {
        if (prop=='scroll-left' || prop=='scrollLeft') {
            e.scrollLeft(parseInt(value));
            return;
        }
        super.setCSS(e,prop,value);
    }

    public getCSS(e:JQuery,prop:string) {
        if (prop=='scroll-left') {
            if (e.css('--scroll-left')===undefined) {
                return this.animatedElement.scrollLeft()+'px';
            }
            return this.getCalcValue(e.css('--scroll-left'))+'px';
        }
        return super.getCSS(e,prop);
    }

    public before() {
        let val=this.fromValue;
        if (val===null) {
            val=this.element.scrollLeft()??0;
            this.from(val);
        }
        this.element.scrollLeft(typeof val=='string'?parseInt(val):0);
    }

    public from(value:string|number) {
        this.fromValue=value;
        this.fromItem.css('--scroll-left',this.px(value));
        return this;
    }

    public to(value:string|number) {
        this.toValue=value;
        this.toItem.css('--scroll-left',this.px(value));
        return this;
    }

    private getCalcValue(value:string) {
        let sw=Math.max(0,this.element[0].scrollWidth-(this.element.width()??0));
        let mdiv=$('<div>',{css:{position:'absolute',width:sw+'px'}});
        let minner=$('<div>',{css:{position:'absolute',width:value}});
        mdiv.append(minner);
        this.element.append(mdiv);
        var computed=minner.width();
        mdiv.remove();
        return computed;
    }

}

export {};